import { render } from "./material-explode-bar.vue?vue&type=template&id=e4227666&ts=true"
import script from "./material-explode-bar.vue?vue&type=script&lang=ts"
export * from "./material-explode-bar.vue?vue&type=script&lang=ts"

import "./material-explode-bar.vue?vue&type=style&index=0&id=e4227666&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__